var EExtendsMergeStrategy = /*#__PURE__*/ function(EExtendsMergeStrategy) {
    EExtendsMergeStrategy["Append"] = "append";
    EExtendsMergeStrategy["Overwrite"] = "overwrite";
    EExtendsMergeStrategy["Clear"] = "clear";
    /**
     * Introducing Keep as strategy to keep values from extended template.
     *
     * @see https://app.clickup.com/t/861m6y395 (CU-861m6y395)
     * */ EExtendsMergeStrategy["Keep"] = "keep";
    return EExtendsMergeStrategy;
}(EExtendsMergeStrategy || {});
var ETemplateStatus = /*#__PURE__*/ function(ETemplateStatus) {
    ETemplateStatus["Draft"] = "draft";
    ETemplateStatus["Published"] = "published";
    return ETemplateStatus;
}(ETemplateStatus || {});
var ERcbTier = /*#__PURE__*/ function(ERcbTier) {
    ERcbTier["Free"] = "free";
    ERcbTier["Pro"] = "pro";
    return ERcbTier;
}(ERcbTier || {});
var EWhenOneOfCondition = /*#__PURE__*/ function(EWhenOneOfCondition) {
    EWhenOneOfCondition["IsWordPressPluginOrThemeActive"] = "is-wordpress-plugin-or-theme-active";
    return EWhenOneOfCondition;
}(EWhenOneOfCondition || {});
var ETemplateMetaDataVersionUpdateState = /*#__PURE__*/ function(ETemplateMetaDataVersionUpdateState) {
    ETemplateMetaDataVersionUpdateState["Initial"] = "initial";
    ETemplateMetaDataVersionUpdateState["Update"] = "update";
    ETemplateMetaDataVersionUpdateState["Notify"] = "notify";
    ETemplateMetaDataVersionUpdateState["Removed"] = "removed";
    ETemplateMetaDataVersionUpdateState["NeverReleased"] = "never-released";
    return ETemplateMetaDataVersionUpdateState;
}(ETemplateMetaDataVersionUpdateState || {});
/**
 * Represents the fields of a base template meta data.
 */ var TemplateMetaDataField = /*#__PURE__*/ function(TemplateMetaDataField) {
    TemplateMetaDataField["CreatedAt"] = "createdAt";
    TemplateMetaDataField["EnabledWhenOneOf"] = "enabledWhenOneOf";
    TemplateMetaDataField["Extends"] = "extends";
    TemplateMetaDataField["ExtendedMergeStrategies"] = "extendedMergeStrategies";
    TemplateMetaDataField["ExtendedTemplateId"] = "extendedTemplateId";
    TemplateMetaDataField["ExtendsId"] = "extendsId";
    TemplateMetaDataField["ExtendsIdentifier"] = "extendsIdentifier";
    TemplateMetaDataField["Headline"] = "headline";
    TemplateMetaDataField["Id"] = "id";
    TemplateMetaDataField["Identifier"] = "identifier";
    TemplateMetaDataField["IsDeleted"] = "isDeleted";
    TemplateMetaDataField["IsExtendingMetaData"] = "isExtendingMetaData";
    TemplateMetaDataField["IsFavourite"] = "isFavourite";
    TemplateMetaDataField["MachineTranslationStatus"] = "machineTranslationStatus";
    TemplateMetaDataField["IsHidden"] = "isHidden";
    TemplateMetaDataField["LastEditedBy"] = "lastEditedBy";
    TemplateMetaDataField["Logo"] = "logo";
    TemplateMetaDataField["LogoId"] = "logoId";
    TemplateMetaDataField["MinRequiredRcbVersion"] = "minRequiredRcbVersion";
    TemplateMetaDataField["Name"] = "name";
    TemplateMetaDataField["NameTranslationFlags"] = "nameTranslationFlags";
    TemplateMetaDataField["Next"] = "next";
    TemplateMetaDataField["NextId"] = "nextId";
    TemplateMetaDataField["Pre"] = "pre";
    TemplateMetaDataField["PreId"] = "preId";
    TemplateMetaDataField["RecommendedWhenOneOf"] = "recommendedWhenOneOf";
    TemplateMetaDataField["ReleaseStatus"] = "releaseStatus";
    TemplateMetaDataField["SubHeadline"] = "subHeadline";
    TemplateMetaDataField["Status"] = "status";
    TemplateMetaDataField["SuccessorOfIdentifier"] = "successorOfIdentifier";
    TemplateMetaDataField["SuccessorOfIdentifierInfo"] = "successorOfIdentifierInfo";
    TemplateMetaDataField["Tier"] = "tier";
    TemplateMetaDataField["TranslationInfo"] = "translationInfo";
    TemplateMetaDataField["Version"] = "version";
    return TemplateMetaDataField;
}(TemplateMetaDataField || {});
export { TemplateMetaDataField, EExtendsMergeStrategy, ERcbTier, ETemplateMetaDataVersionUpdateState, ETemplateStatus, EWhenOneOfCondition };
